import React from 'react'

import { 
    useFormContext,
    Controller 
} from "react-hook-form"

import {
    ErrorText,
    RedTint
} from '../../../Styles/BaseStyles'

import { 
    SectionDiv, 
    HeaderDiv, 
    FormDiv, 
    SectionHeader, 
    ApplicationRowDiv,
    LeftApplicationDiv,
    RightApplicationDiv,
    ApplicationHeader,
    InputField,
} from  '../../../Styles/Components/ApplicationSectionStyles'

// Redux selector

import { useSelector } from "react-redux"

import LocationSearchInput from '../../Action/LocationSearchInput'

function ContactInfoSection(props) {

    const { register, errors, control } = useFormContext()

    const locked = useSelector(state => state.appViewer.locked)
    
    return (
        <SectionDiv id = {props.name}>
            <HeaderDiv>
                <SectionHeader>Contact Information</SectionHeader>
            </HeaderDiv>
            <FormDiv>
                <ApplicationRowDiv>
                    <LeftApplicationDiv>
                        <ApplicationHeader>Name<RedTint>*</RedTint></ApplicationHeader>
                        <InputField 
                            type="text" name="contact_information.name" placeholder="Name" 
                            ref={
                                register({
                                    required: {
                                        value: true,
                                        message: 'required field'
                                    },
                                    maxLength: {
                                        value: 70,
                                        message: 'exceeds 70 character limit'
                                    }, 
                                    pattern: {
                                        value: /^[a-zA-Z0-9àáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð' -]+$/u,
                                        message: 'invalid character usage'
                                    }
                                })
                            } 
                            readOnly={locked}
                        />
                        {errors['contact_information'] != null && errors['contact_information']['name'] != null && <ErrorText p={0} ml={0} mr={0} mt="0.25rem">{'*'+errors['contact_information']['name']['message']}</ErrorText>}
                    </LeftApplicationDiv>
                    <RightApplicationDiv>
                        <ApplicationHeader>Email<RedTint>*</RedTint></ApplicationHeader>
                        <InputField 
                            type="text" name="contact_information.email" placeholder="Email" 
                            ref={
                                register({
                                    required: {
                                        value: true,
                                        message: 'required field'
                                    },
                                    maxLength: {
                                        value: 320,
                                        message: 'exceeds 320 character limit'
                                    }, 
                                    pattern: {
                                        value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                        message: 'invalid format or character usage'
                                    }
                                })
                            } 
                            readOnly={locked}
                        />
                        {errors['contact_information'] != null && errors['contact_information']['email'] != null && <ErrorText p={0} ml={0} mr={0} mt="0.25rem">{'*'+errors['contact_information']['email']['message']}</ErrorText>}
                    </RightApplicationDiv>
                </ApplicationRowDiv>
                <ApplicationRowDiv>
                    <LeftApplicationDiv>
                        <ApplicationHeader>Phone Number<RedTint>*</RedTint></ApplicationHeader>
                        <InputField 
                            type="text" name="contact_information.phone_number" placeholder="Phone Number" 
                            ref={
                                register({
                                    required: {
                                        value: true,
                                        message: 'required field'
                                    },
                                    maxLength: {
                                        value: 20,
                                        message: 'exceeds 20 character limit'
                                    },  
                                    pattern: {
                                        value: /^((\+)?\d{1,2}[-\s\.]?)?\(?\d{3}\)?[-\s\.]?\d{3}[-\s\.]?\d{4}$/,
                                        message: 'invalid format or character usage'
                                    } 
                                })
                            } 
                            readOnly={locked}
                        />
                        {errors['contact_information'] != null && errors['contact_information']['phone_number'] != null && <ErrorText p={0} ml={0} mr={0} mt="0.25rem">{'*'+errors['contact_information']['phone_number']['message']}</ErrorText>}
                    </LeftApplicationDiv>
                    <RightApplicationDiv>
                        <ApplicationHeader>Location<RedTint>*</RedTint></ApplicationHeader>
                        <Controller
                            render={(props) => (
                                <LocationSearchInput
                                    onChange={(value) => {
                                        props.onChange(value)
                                    }}
                                    value={props.value}
                                />
                            )}
                            onChange={(value) => this.handleChange(value)}
                            name="contact_information.location"
                            errors={errors}
                            control={control}
                            rules={
                                { 
                                    required: {
                                        value: true,
                                        message: 'select a location' 
                                    }
                                }
                            }
                        />
                        {errors['contact_information'] != null && errors['contact_information']['location'] != null && <ErrorText p={0} ml={0} mr={0} mt="0.25rem">{'*'+errors['contact_information']['location']['message']}</ErrorText>}
                    </RightApplicationDiv>
                </ApplicationRowDiv>
            </FormDiv>
        </SectionDiv>
    )
}

export default ContactInfoSection;